
<div class="parent fx-row">
  <div class="left">
    <about-company></about-company>
  </div>
  <div class="right">
    <section>
      <form [formGroup]="companyBranchForm">
        <mat-card>
          <h2>
            Select Company
          </h2>
          <h5 class="mat-h5-paragraph">Choose your company and branch to continue</h5>
          <mat-card-content>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" hideRequiredMarker class="company-field">
              <mat-label>Company</mat-label>
              <mat-select (selectionChange)="getBranchesByCompanyId($event.value)" formControlName="companyName">
                @for (company of companys; track company) {
                  <mat-option [disabled] = "company.isCompanyDeactivated" [value]="company.name">{{company.name}}</mat-option>
                }
              </mat-select>
              @if (companyName.touched && companyName.invalid && companyName.hasError('required')) {
                <mat-error>Company selection is required</mat-error>
              }
            </mat-form-field>
            <div class="field-spacer"></div>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" hideRequiredMarker class="branch-field">
              <mat-label>Branch</mat-label>
              <mat-select (selectionChange)="branchChanged($event.value)">
                @for (branch of companyBranches; track branch) {
                  <mat-option [disabled] = "branch.isBranchDeactivated" [value]="branch.branchId" >{{branch.name}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </mat-card-content>
          <div class="different-user-row">
            <a class="different-user-link" (click)="loginInWithDifferentUser()">Login as a different user</a>
          </div>
          <mat-card-actions>
            <div class="button-flex-container">
              <button type="button" class="material-cust-large-button" color="primary" (click)="onSubmit()">Login</button>
            </div>
          </mat-card-actions>
        </mat-card>
      </form>
    </section>
  </div>
</div>
